<script lang="ts">
import SectionEtablissementContacts from '@/generated/sections/SectionEtablissementContacts.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionEtablissementContacts
})

</script>
